import api, { request } from '../../../../api';
import { IErrorsStore } from '../../../errors/store';
import { IStore } from '../../../index';
import { IEventRegistration } from '../store';

export const getRegistrationSummary = async (
  _: IStore,
  event: number,
  addons: number[],
  coupon?: string
): Promise<{ eventRegistration?: IEventRegistration; errors?: IErrorsStore }> => {
  const body: any = { addons, event };
  if (coupon) {
    body.coupon = coupon;
  }
  const response = await request.post(`${api.eventRegistration}summary/`, body);

  if (response.error) {
    return { errors: { eventRegistration: { msg: 'Error getting event checkout summary ' } } };
  }

  const summary: IEventRegistration = response;
  return { eventRegistration: summary };
};
